import React, { useEffect, useState } from "react";
import CommonDataTable from "../CommonDataTable";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import IconButton from "../IconButton";
import useGetApi from "../../services/useGetApi";
import usePost from "../../services/usePost";
import useDelete from "../../services/useDelete";
import { Button } from "antd";

const PendingApplicationsTab = ({key}) => {
  const [loading, setLoading] = useState(false);

  const [isLoading, error, applicationData, getData] = useGetApi(
    `applications/status?status=0`,
    [],
    true
  );

    const [isApplicationLoading, isApplicationError, application, getApplication] = useGetApi(
      ``,
      [],
      true
    );

  const [isPostLoading, errorMsg, postData] = usePost();
  const [isDeleteLoading, deleteError, deleteData] = useDelete();


  useEffect(() => {
    getData(`applications/status?status=0`);
  }, [key]);

  const handleEdit = () => {
    console.log("edit");
  };
  
    //update status in api
    const handleUpdateApproval = async(response) => {
     
      response.status = 1
  
      const result = await postData(`applications`,response,true)
      
      if(result){
        getData(`applications/status?status=0`);
      }
    }

    const handleApproval = async(id) => {

      if(id){
        const response = await getApplication(`applications/${id}`)
        if(response){
          // console.log(response,'res')
          handleUpdateApproval(response)
        }
      }
    };

  const handleDelete = async(id) => {

    const response = await deleteData(`applications/${id}`)

    if(response){
      getData(`applications/status?status=0`);
    }

  }

  const handleView = () => {
    console.log("handleView");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "user.firstName",
      key: "user.firstName",
      render: (_, record) => (
        <div>
          {record.user
            ? `${record.user.firstName}  ${record.user.lastName}`
            : "NA"}
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          {/* <IconButton
            icon={EditOutlined}
            onClick={handleEdit}
            style={{ color: "blue" }}
          /> */}
          <IconButton
            icon={DeleteOutlined}
            onClick={() => handleDelete(record.id)}
            style={{ color: "red" }}
          />
          {/* <IconButton
            icon={EyeOutlined}
            onClick={handleView}
            style={{ color: "green" }}
          /> */}
          <Button onClick={() => handleApproval(record.id)}>Approve</Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <CommonDataTable
        columns={columns}
        dataSource={applicationData}
        loading={loading}
        tableTitle={""}
      />
    </div>
  );
};

export default PendingApplicationsTab;
